import { AdminListOffersFilter, } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListOffersCountApi = async (
  filter: AdminListOffersFilter,
): Promise<Record<string, number>> => {
  const result = await executeGql<string>(adminListOffersCountQuery, { filter });
  const json = JSON.parse(processGqlResult<string>('adminListOffersCount', result));
  return json.items;
};

const adminListOffersCountQuery = /* GraphQL */ `
  query AdminListOffersCountQuery($filter: AdminListOffersFilter!) {
    adminListOffersCount(filter: $filter)
  }
`;
